import { IS_DEV, IS_DEV_PUBLISH, IS_TEST, IS_PRE, platform } from '@/common/constant';

// 公网域名
const avaliableDomainList: string[] = [];
const domainList = ['pan.tencent.com'];
domainList.forEach(domain => {
  avaliableDomainList.push(domain);
  ['dev', 'test', 'pre', 'test1', 'test2'].forEach(env => {
    avaliableDomainList.push(`${env}.${domain}`);
  });
});
const defaultDomain = 'pan.tencent.com';

// 当前域名，pc端默认pan.tencent.com，企微登录用到
const currentDomain = (function getDomain() {
  if (platform === 'browser') {
    const isIp = /^(\d+)\.(\d+)\.(\d+)\.(\d+)/g.test(window.location.host);
    const isLocalhost = window.location.hostname === 'localhost';
    return isIp || isLocalhost ? defaultDomain : window.location.host;
  }
  return defaultDomain;
})();

// 是否自定义域名
const isCustomizedDomain = (function isCustomizedDomain() {
  if (platform !== 'browser') return false;
  return !avaliableDomainList.includes(currentDomain) || window.location.search.includes('domain_prefix');
})();

const isTestApp = IS_DEV || IS_DEV_PUBLISH || IS_TEST;
const sdkId = isTestApp ? '20940263730' : '18530189451';
// 腾讯会议授权页面
const meetingAuthUrl = `https://meeting.tencent.com/authorize.html?corp_id=1400115281&sdk_id=${sdkId}&redirect_uri=`;

export default {
  // 腾讯网盘官网
  officialWebsiteUrl: 'https://pan.tencent.com',
  // 腾讯网盘下载中心
  officialWebsiteDowloadUrl: 'https://pan.tencent.com/download',
  // 腾讯网盘官网开发调试环境
  officialWebsiteUrlDevEnv: 'https://dev.pan.tencent.com',
  // 腾讯网盘官网测试环境
  officialWebsiteUrlTestEnv: 'https://test.pan.tencent.com',
  // 腾讯网盘官网预发布环境
  officialWebsiteUrlPreEnv: 'https://pre.pan.tencent.com',
  // 官网续期页
  consoleManagementUrl: 'https://console.cloud.tencent.com/smh/official-list',
  // 腾讯云工单跳转
  consoleBillUrl: 'https://cloud.tencent.com/online-service?from=sales&source=PRESALE',
  // 资源包管理页
  packageUrl: 'https://console.cloud.tencent.com/smh/traffic-package',
  // 域名备案网页
  domainUrl: 'https://cloud.tencent.com/document/product/243',
  // 公安备案流程页
  psbUrl: 'https://cloud.tencent.com/document/product/243/19142',
  // 应用地址
  appUrl: `https://${currentDomain}`,
  // 应用登录页地址
  appLoginUrl: `https://${currentDomain}/login`,
  // 服务协议
  serviceAgreement: 'https://rule.tencent.com/rule/preview/f764a78c-87ef-4a79-b40a-0a1de5d03180',
  // 私有化服务协议
  privateServiceAgreement: 'https://rule.tencent.com/rule/preview/4f2cc091-5c76-474c-8b7c-004852102cfd',
  // 隐私协议
  privacyAgreement: 'https://privacy.qq.com/document/preview/fbb65e473f29470ebbbc5cbd3d448161',
  // 私有化隐私协议
  privatePrivacyAgreement: 'https://rule.tencent.com/rule/preview/7f5ddcdb-f05e-4b7c-9771-8b6b8096136a',
  // 举报地址
  offenceUrl: 'https://cloud.tencent.com/online-service',
  // 腾讯云在线咨询页面
  consultUrl: 'https://cloud.tencent.com/online-service?from=intro_tced&source=PRESALE',
  purchaseUrl: 'https://buy.cloud.tencent.com/tced',
  // 免费版续费
  freeConsolePurchaseUrl: 'https://console.cloud.tencent.com/tced/official-list',
  // 会议体验购买地址
  channelBuyUrl: `https://buy.cloud.tencent.com/tced_channel?${
    IS_DEV || IS_DEV_PUBLISH || IS_TEST || IS_PRE ? 'version=0f1f69aa54b5effdf65954e5&' : ''
  }`,
  bulletinUrl: 'https://sdi.3g.qq.com/v/2022071915192411519',
  // 企微登录二维码样式覆盖
  wecomQrcodeCss: 'https://tced-static.tencentsmh.cn/tools/qrcode.css',
  // 企微登录二维码样式覆盖
  wechatQrcodeCss: 'https://tced-static.tencentsmh.cn/tools/wechat_qrcode.css',
  // 兔小巢产品反馈
  productFeedbackUrl: 'https://support.qq.com/product/408420',
  // 腾讯网盘 web默认域名
  defaultDomain,
  // 当前域名,pc端默认defaultDomain
  currentDomain,
  // TODO 网盘需要更新授权url
  // 是否自定义域名
  isCustomizedDomain,
  // 腾讯会议授权页面
  meetingAuthUrl,
  // 购买页
  buyUrl: 'https://pan.tencent.com/buy',
  // 测试环境ad广告
  adUrl_test: 'https://test.pan.tencent.com/api/advertise?beta=1',
  // ad广告
  adUrl: 'https://pan.tencent.com/api/advertise',
  buyEnterpriseUrl: 'https://cloud.tencent.com/act/pro/free1month',
  // 企业微信二维码
  enterpriseWechat: 'https://tced-static.tencentsmh.cn/tools/images/qrcode/enterpriseWechat.png',
  // 公众号二维码
  officialAccountWechat: 'https://tced-static.tencentsmh.cn/tools/images/qrcode/officialAccountWechat.jpg',
  // icp备案号跳转链接
  govICPUrl: 'https://beian.miit.gov.cn/#/Integrated/index',
  // psb公安备案号跳转链接
  govPsbUrl: 'https://www.beian.gov.cn/portal/registerSystemInfo',
};
